export type ProjectCategory =
  | 'Ecommerce'
  | 'Custom products & printing'
  | 'Membership & training'
  | 'Service businesses'
  | 'Auto & marine'
  | 'Professional services'
  | 'Industrial & equipment'

export type Project = {
  name: string
  category: ProjectCategory
  /** What the system this project runs on actually supports. */
  supports: string
  accent: 'orange' | 'green' | 'cyan' | 'blue'
  layout: 'catalog' | 'gallery' | 'schedule' | 'booking' | 'listings' | 'specs' | 'intake' | 'store' | 'membership'
  /**
   * TODO (content): add the approved browser capture for this project.
   * Until a verified screenshot exists this stays null and the card renders a clearly
   * marked placeholder rather than presenting an abstract wireframe as finished proof.
   */
  image?: string | null
  /** TODO (content): verified live project URL. Cards do not link out until this is set. */
  url?: string | null
  /** TODO (content): meaningful alt text describing the captured screen. */
  alt?: string | null
}

export const projects: Project[] = [
  {
    name: 'Atomic Apparel Designs',
    category: 'Custom products & printing',
    supports: 'Product discovery, custom transfer ordering, and repeat-purchase workflows.',
    accent: 'orange',
    layout: 'store',
  },
  {
    name: 'Lucky Duck Bathroom Company',
    category: 'Service businesses',
    supports: 'Service education, local market pages, and estimate requests.',
    accent: 'cyan',
    layout: 'gallery',
  },
  {
    name: 'Wear Haus Designs',
    category: 'Custom products & printing',
    supports: 'Decorated apparel and promotional product browsing with quote and order requests.',
    accent: 'orange',
    layout: 'catalog',
  },
  {
    name: 'Koda Group Investigative Services',
    category: 'Professional services',
    supports: 'Service explanation across coverage areas with confidential inquiry handling.',
    accent: 'blue',
    layout: 'intake',
  },
  {
    name: "Fenton Lakes Sportsman's Club",
    category: 'Membership & training',
    supports: 'Membership information, club events, and facility details for prospective members.',
    accent: 'green',
    layout: 'membership',
  },
  {
    name: 'Northwest Black Belt Academy',
    category: 'Membership & training',
    supports: 'Program explanation by age and level, class schedules, and trial enrollment.',
    accent: 'blue',
    layout: 'schedule',
  },
  {
    name: 'USA Bearings & Belts',
    category: 'Industrial & equipment',
    supports: 'Part and specification lookup with sourcing inquiries for technical buyers.',
    accent: 'orange',
    layout: 'specs',
  },
  {
    name: 'Best Vitamins For All',
    category: 'Ecommerce',
    supports: 'Catalog browsing, product education, and direct online purchasing.',
    accent: 'green',
    layout: 'catalog',
  },
  {
    name: 'Garrett Auto & Truck Service',
    category: 'Auto & marine',
    supports: 'Trust-building service content and repair inquiries across auto, truck, and diesel work.',
    accent: 'cyan',
    layout: 'booking',
  },
  {
    name: 'Loud Mouth Studio',
    category: 'Professional services',
    supports: 'Studio capability presentation with session and production inquiries.',
    accent: 'orange',
    layout: 'booking',
  },
  {
    name: 'Mash Gym',
    category: 'Membership & training',
    supports: 'Training program explanation, schedules, and new-member inquiries.',
    accent: 'green',
    layout: 'schedule',
  },
  {
    name: 'Che Ko Martial Arts',
    category: 'Membership & training',
    supports: 'Class and program details for families, with trial and enrollment requests.',
    accent: 'blue',
    layout: 'schedule',
  },
  {
    name: 'Walkers Martial Arts',
    category: 'Membership & training',
    supports: 'Program positioning by age group with enrollment and schedule information.',
    accent: 'orange',
    layout: 'membership',
  },
  {
    name: 'Down Home Interiors',
    category: 'Service businesses',
    supports: 'Portfolio-led presentation of interior work with consultation requests.',
    accent: 'green',
    layout: 'gallery',
  },
  {
    name: 'Precision Pro Sprayers',
    category: 'Industrial & equipment',
    supports: 'Equipment and application detail with sales and service inquiries.',
    accent: 'cyan',
    layout: 'specs',
  },
  {
    name: 'Switchplate Gallery',
    category: 'Ecommerce',
    supports: 'Large decorative catalog browsing by style, finish, and configuration.',
    accent: 'orange',
    layout: 'catalog',
  },
  {
    name: 'Desert Sage Seminars',
    category: 'Professional services',
    supports: 'Course selection, requirement explanation, and online enrollment.',
    accent: 'blue',
    layout: 'intake',
  },
  {
    name: 'Storm Taekwondo',
    category: 'Membership & training',
    supports: 'Youth program explanation with schedule details and enrollment requests.',
    accent: 'green',
    layout: 'schedule',
  },
  {
    name: 'Koda Group Security Services',
    category: 'Professional services',
    supports: 'Security service capability, coverage detail, and qualified inquiries.',
    accent: 'blue',
    layout: 'intake',
  },
  {
    name: 'Paragon Chiropractic',
    category: 'Professional services',
    supports: 'Care explanation, provider information, and new-patient intake.',
    accent: 'green',
    layout: 'intake',
  },
  {
    name: 'Impact Auto Body',
    category: 'Auto & marine',
    supports: 'Collision repair process explanation with estimate and claim inquiries.',
    accent: 'cyan',
    layout: 'booking',
  },
  {
    name: 'CLR Marine',
    category: 'Auto & marine',
    supports: 'Marine product discovery, parts and service information, and customer inquiries.',
    accent: 'cyan',
    layout: 'listings',
  },
  {
    name: "Sam's Disposal",
    category: 'Service businesses',
    supports: 'Service area and schedule clarity with new service requests.',
    accent: 'orange',
    layout: 'booking',
  },
  {
    name: 'Brammers Athletic',
    category: 'Custom products & printing',
    supports: 'Team and custom apparel programs with ordering and artwork requests.',
    accent: 'orange',
    layout: 'store',
  },
  {
    name: 'GulfCoastLanterns',
    category: 'Ecommerce',
    supports: 'Handcrafted product presentation with configuration and online ordering.',
    accent: 'orange',
    layout: 'catalog',
  },
  {
    name: 'SHED GIRLS',
    category: 'Industrial & equipment',
    supports: 'Building and carport configuration with specification-based quote requests.',
    accent: 'green',
    layout: 'specs',
  },
  {
    name: 'C&C Custom-Transfers LLC',
    category: 'Custom products & printing',
    supports: 'Custom transfer ordering, artwork handling, and repeat purchasing.',
    accent: 'cyan',
    layout: 'store',
  },
  {
    name: 'SXS Factory',
    category: 'Ecommerce',
    supports: 'Fitment-driven parts browsing and online purchasing for powersports buyers.',
    accent: 'blue',
    layout: 'listings',
  },
  {
    name: 'Todays TaeKwonDo',
    category: 'Membership & training',
    supports: 'Competitive program explanation with class schedules and enrollment.',
    accent: 'orange',
    layout: 'membership',
  },
  {
    name: "Kosin's Glass",
    category: 'Auto & marine',
    supports: 'Glass service explanation with repair and replacement requests.',
    accent: 'cyan',
    layout: 'booking',
  },
]

export const projectCategories: ProjectCategory[] = [
  'Ecommerce',
  'Custom products & printing',
  'Membership & training',
  'Service businesses',
  'Auto & marine',
  'Professional services',
  'Industrial & equipment',
]
